"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _require = require("../helpers/create-event-accessor"),
    appendHandler = _require.appendHandler,
    createEventAccessor = _require.createEventAccessor;

var events = new Set(["abort", "autocomplete", "autocompleteerror", "blur", "cancel", "canplay", "canplaythrough", "change", "click", "close", "contextmenu", "cuechange", "dblclick", "drag", "dragend", "dragenter", "dragleave", "dragover", "dragstart", "drop", "durationchange", "emptied", "ended", "error", "focus", "input", "invalid", "keydown", "keypress", "keyup", "load", "loadeddata", "loadedmetadata", "loadstart", "mousedown", "mouseenter", "mouseleave", "mousemove", "mouseout", "mouseover", "mouseup", "wheel", "pause", "play", "playing", "progress", "ratechange", "reset", "resize", "scroll", "securitypolicyviolation", "seeked", "seeking", "select", "sort", "stalled", "submit", "suspend", "timeupdate", "toggle", "volumechange", "waiting"]);

var GlobalEventHandlersImpl = /*#__PURE__*/function () {
  function GlobalEventHandlersImpl() {
    _classCallCheck(this, GlobalEventHandlersImpl);
  }

  _createClass(GlobalEventHandlersImpl, [{
    key: "_initGlobalEvents",
    value: function _initGlobalEvents() {
      this._registeredHandlers = new Set();
      this._eventHandlers = Object.create(null);
    }
  }, {
    key: "_getEventHandlerTarget",
    value: function _getEventHandlerTarget() {
      return this;
    }
  }, {
    key: "_getEventHandlerFor",
    value: function _getEventHandlerFor(event) {
      var target = this._getEventHandlerTarget(event);

      if (!target) {
        return null;
      }

      return target._eventHandlers[event];
    }
  }, {
    key: "_setEventHandlerFor",
    value: function _setEventHandlerFor(event, handler) {
      var target = this._getEventHandlerTarget(event);

      if (!target) {
        return;
      }

      if (!target._registeredHandlers.has(event) && handler !== null) {
        target._registeredHandlers.add(event);

        appendHandler(target, event);
      }

      target._eventHandlers[event] = handler;
    }
  }, {
    key: "_globalEventChanged",
    value: function _globalEventChanged(event) {
      var propName = "on" + event;

      if (!(propName in this)) {
        return;
      } // Only translate attribute changes into properties when runScripts: "dangerously" is set.
      // Documents without a browsing context (i.e. without a _defaultView) never run scripts.


      var runScripts = "_runScripts" in this ? this._runScripts : (this._ownerDocument._defaultView || {})._runScripts;

      if (runScripts !== "dangerously") {
        return;
      }

      var val = this.getAttributeNS(null, propName);
      var handler = val === null ? null : {
        body: val
      };

      this._setEventHandlerFor(event, handler);
    }
  }]);

  return GlobalEventHandlersImpl;
}();

var _iterator = _createForOfIteratorHelper(events),
    _step;

try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var event = _step.value;
    createEventAccessor(GlobalEventHandlersImpl.prototype, event);
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}

module.exports = {
  implementation: GlobalEventHandlersImpl
};